import Transform from "@ember-data/serializer/transform";

export default class OtherFollowUpEventsTransform extends Transform {
  override deserialize(serialized) {
    serialized?.forEach(event => {
      // Make sure date are of type Date and not string.
      // This is useful when passing the date in a DatePicker, which must have a Date and not a string.
      if (event.date) {
        event.date = new Date(event.date);
      }
    });
    return serialized;
  }

  override serialize(deserialized) {
    return deserialized;
  }
}

declare module "ember-data/types/registries/transform" {
  export default interface TransformRegistry {
    "other-follow-up-events": OtherFollowUpEventsTransform;
  }
}
